import tw, { styled } from 'twin.macro'
import React from 'react'
import PropTypes from 'prop-types'
import { HeadingLeftMinor, ContentWrapperSmall } from './Typography'
import ButtonLink from './ButtonLink'
import { HTMLContent } from './Content'

const RelatedItemsContainer = styled('div')`
  ${tw`max-w-6xl mx-auto my-8 grid sm:grid-cols-2 gap-4`}
  ${props => props.itemsCount > 3 ? tw`md:grid-cols-4` : tw`md:grid-cols-3`}
`

const RelatedItem = styled('div')`
  ${tw`bg-gray-50 sm:rounded-lg leading-normal p-6 flex flex-col`}
`

const RelatedItemButtonWrapper = styled('div')`
  ${tw`-ml-3 mt-6 flex`}

  a {
    ${tw`mx-auto`}
  }
`

const VerticalSpacer = styled('div')`
  ${tw`my-auto`}
`

const RelatedItems = ({ items }) => {
  return items && items.length > 0 && (
    <RelatedItemsContainer itemsCount={items.length}>
      {items.map((item, index) => (
        <RelatedItem key={index}>
          {item.title && <HeadingLeftMinor>{item.title}</HeadingLeftMinor>}
          {item.description && <ContentWrapperSmall>
            <HTMLContent content={item.description} />
          </ContentWrapperSmall>}
          <VerticalSpacer />
          {item.buttonLink && item.buttonTitle && <RelatedItemButtonWrapper>
            <ButtonLink small red to={item.buttonLink}>{item.buttonTitle}</ButtonLink>
          </RelatedItemButtonWrapper>}
        </RelatedItem>
      ))}
    </RelatedItemsContainer>
  );
}

RelatedItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    buttonLink: PropTypes.string,
    buttonTitle: PropTypes.string,
  }))
}

export default RelatedItems
